<template>
  <NavigationHeader />
  <NuxtLoadingIndicator
    :height="10"
    :throttle="0"
  />
  <main>
    <slot />
  </main>
  <NavigationFooter />
</template>
